import { useState } from "react"
import { Button, Form, Modal } from "react-bootstrap"
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { getPasswordChange } from "../../../apifile/ApiFiles";
import { toast, ToastContainer } from "react-toastify";


const PasswordChange = (props) => {

    const [initialValue, setInitialValue] = useState({
        _id: '',
        password: "",
        newPassword: "",
    });

    const [showPassword, setShowPassword] = useState({
        password: false,
        newPassword: false,
    });

    const changeValue = (e) => {
        const { name, value } = e.target;
        setInitialValue((prev) => ({ ...prev, [name]: value }));
    };

    const toggleVisibility = (field) => {
        setShowPassword((prev) => ({
            ...prev,
            [field]: !prev[field],
        }));
    };

    const isSubmitDisabled =
        !initialValue.password ||
        !initialValue.newPassword ||
        initialValue.password !== initialValue.newPassword;



    const toastSuccessMessage = (message) => {
        toast.success(`${message}`, {
            position: "top-right",
        });
    };
    const postApiData = async () => {
        const clone = { ...initialValue, _id: props?.passid }
        try {
            const res = await getPasswordChange(clone);
            if (res?.data?.error == false) {
                toastSuccessMessage(res?.data?.message)
                setTimeout(() => {
                    props?.onHide()
                }, 1000)
                setInitialValue({
                    _id: '',
                    password: "",
                    newPassword: "",
                })
            }
        } catch (error) {
            console.error("Error changing password:", error);
        }
    };
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Password Change
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3" controlId="password">
                        <Form.Label>Password</Form.Label>
                        <div className="d-flex align-items-center">
                            <Form.Control
                                type={showPassword.password ? "text" : "password"}
                                placeholder="Enter Password"
                                name="password"
                                value={initialValue.password}
                                onChange={changeValue}
                            />
                            <span
                                onClick={() => toggleVisibility("password")}
                                className="ms-2"
                                style={{ cursor: "pointer" }}
                            >
                                {showPassword.password ? <FaEyeSlash /> : <FaEye />}
                            </span>
                        </div>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="newPassword">
                        <Form.Label>Confirm Password</Form.Label>
                        <div className="d-flex align-items-center">
                            <Form.Control
                                type={showPassword.newPassword ? "text" : "password"}
                                placeholder="Confirm Password"
                                name="newPassword"
                                value={initialValue.newPassword}
                                onChange={changeValue}
                            />
                            <span
                                onClick={() => toggleVisibility("newPassword")}
                                className="ms-2"
                                style={{ cursor: "pointer" }}
                            >
                                {showPassword.newPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                        </div>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
                <Button type="button" onClick={postApiData}
                    disabled={isSubmitDisabled}>Submit</Button>
            </Modal.Footer>
            <ToastContainer />
        </Modal>
    )
}

export default PasswordChange